import { useState, useEffect } from 'react';
import axios from 'axios';

export default function useCompanySettings() {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    async function fetchSettings() {
      try {
        const [sysRes, subRes] = await Promise.all([
          axios.get('https://pdks.bytebridge.com.tr/api/company-settings'),
          axios.get('https://pdks.bytebridge.com.tr/api-validity', { params: { port: 5001 } }),
        ]);
        const sys = sysRes.data;
        const sub = subRes.data;
        setSettings({
          ...sys,
          package: sub.paket,
          validUntil: sub.valid_until,
          customerName: sub.customer_name,
          locationCount: sub.location_count,
          employeeCount: sub.employee_count,
          rfidCount: sub.rfid_count,
        });
      } catch (error) {
        setSettings(null);
      }
    }
    fetchSettings();
  }, []);
  return settings;
}
